<div *ngIf="configuration">
    <!-- <span class="bold">MSRP: {{ configuration.totalMsrp | currency }}</span> -->
    
    <div class="content-container">
	    <div class="groups-container">
	    
	       <div id="back-wrap">
			    <a (click)="back()" class="back">
			        <svg class="back-arrow" width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			            <path d="M 14 1 L 24 10 M 14 19 L 24 10 H 1" stroke="currentcolor"
			                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
			        </svg>
			        <span class="back-text">Back to Search &amp; Browse</span>
			    </a>
			    <button *ngIf="showSave() && isValid()" id="add-to-quote-button" (click)="save()">Add to Proposal</button>
		    </div>
	       
	       <div id="config-header">
	           <h1>{{ configuration.description }}</h1>
	           <div>
	               <input type="checkbox" (change)="toggleIncludeConfigurationImage()"
	                   [(ngModel)]="configuration.includeConfigurationImage" />
				   <span class="text-wrap">
				       <span class="description">Include Configuration Image in Proposal</span>
				   </span>
	           </div>
	           <div>
                   <input type="checkbox" (change)="toggleIncludePageNumbers()"
                       [(ngModel)]="configuration.includePartNumbers" />
                   <span class="text-wrap">
                       <span class="description">Show Part Numbers</span>
                   </span>
               </div>
	       </div>
	       
	       <div #optionsContainer id="options-container">
		       <div *ngIf="!configuration.groups?.length">
	               This {{ configuration.description }} does not require configuration.
	           </div>
	           
	            <div *ngFor="let group of configuration.groups">
	                <h2>{{ group.name }} <span *ngIf="group.required" class="required">(Required)</span></h2>
	                
	                <div *ngFor="let option of group.options" class="non-quantity-group">
	                
	                    <app-option [option]="option" 
	                        (changeOption)="changeOption(group, option)"></app-option>
	                
	                </div>
	                
	                <div *ngFor="let qg of group.quantityGroups">
	                    
	                    <div [ngClass]=" { 'quantity-group': qg.items.length > 1, 'non-quantity-group': qg.items.length === 1 }">
	                        
	                        <div *ngIf="qg.items.length > 1" class="bold quantity-group-header">
	                            Minimum: {{ qg.min }} Maximum: {{ qg.max }}
	                        </div>
	                    
	                        <div *ngFor="let item of qg.items">
	                        
	                            <app-option [option]="item" (changeOption)="changeOption(group, item)"
	                               (changeQuantity)="changeQuantity(group, item)"></app-option>
	                            <select *ngIf="item.included" 
	                                class="qty-select"
	                                [(ngModel)]="item.quantity" (change)="changeQuantity(group, item)">
	                                <option *ngFor="let op of item.quantityOptions" [value]="op">{{ op }}</option>
	                            </select>
	                        </div>
	                    </div>
	                    
	                </div>
	                
	                <div *ngIf="group.additionalOptions.length > 0" class="non-quantity-group">
	                    <h3>Additional Options</h3>
	                    <div *ngFor="let ao of group.additionalOptions">
	                        
	                        <app-option [option]="ao" (changeOption)="changeOption(group, ao)"></app-option>
	                    </div>        
	                </div>
	            </div>
	       
	       </div>
	       
	       <div *ngIf="!!configuration.itemImages.length" class="image-select mobile">
               <div>Select an image to be included in the PDF</div>
               <div class="item-select-images">
                   <div *ngFor="let img of configuration.itemImages" 
                      [ngClass]="{ 'selected': img.selected }"
                       class="item-image" (click)="selectImage( img )">
                       <div class="thumbnail-wrap">
                           <img [src]="img.thumbnail" />
                       </div>
                       <div class="image-description">{{ img.description }}</div>
                   </div>
               </div>
            </div>
            
	    </div>
	    
	    <div class="image-container">
	        <div id="configuration-image">
	           <img [src]="'api/configurations/' + configuration.itemId + '/image'">
	        </div>
	        
	        <div *ngIf="!!configuration.itemImages.length" class="image-select">
	           <div>Select an image to be included in the PDF</div>
	           <div class="item-select-images">
		           <div *ngFor="let img of configuration.itemImages" 
		              [ngClass]="{ 'selected': img.selected }"
		               class="item-image" (click)="selectImage( img )">
	                   <div class="thumbnail-wrap">
	                       <img [src]="img.thumbnail" />
	                   </div>
	                   <div class="image-description">{{ img.description }}</div>
	               </div>
	           </div>
	        </div>
	    </div>
    </div>
    
</div>